"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: miimosa/common/v1/recovery_status.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.recoveryStatusToJSON = exports.recoveryStatusFromJSON = exports.RecoveryStatus = void 0;
/* eslint-disable */
/** CP = Collective Procedure */
exports.RecoveryStatus = {
    RECOVERY_STATUS_UNSPECIFIED: "RECOVERY_STATUS_UNSPECIFIED",
    RECOVERY_STATUS_ANALYSIS: "RECOVERY_STATUS_ANALYSIS",
    RECOVERY_STATUS_FOLLOW_UP: "RECOVERY_STATUS_FOLLOW_UP",
    RECOVERY_STATUS_AMICABLE: "RECOVERY_STATUS_AMICABLE",
    RECOVERY_STATUS_LITIGATION: "RECOVERY_STATUS_LITIGATION",
    RECOVERY_STATUS_CP_SAVE: "RECOVERY_STATUS_CP_SAVE",
    RECOVERY_STATUS_CP_RECOVERY: "RECOVERY_STATUS_CP_RECOVERY",
    RECOVERY_STATUS_CP_LIQUIDATION: "RECOVERY_STATUS_CP_LIQUIDATION",
    UNRECOGNIZED: "UNRECOGNIZED",
};
function recoveryStatusFromJSON(object) {
    switch (object) {
        case 0:
        case "RECOVERY_STATUS_UNSPECIFIED":
            return exports.RecoveryStatus.RECOVERY_STATUS_UNSPECIFIED;
        case 1:
        case "RECOVERY_STATUS_ANALYSIS":
            return exports.RecoveryStatus.RECOVERY_STATUS_ANALYSIS;
        case 2:
        case "RECOVERY_STATUS_FOLLOW_UP":
            return exports.RecoveryStatus.RECOVERY_STATUS_FOLLOW_UP;
        case 3:
        case "RECOVERY_STATUS_AMICABLE":
            return exports.RecoveryStatus.RECOVERY_STATUS_AMICABLE;
        case 4:
        case "RECOVERY_STATUS_LITIGATION":
            return exports.RecoveryStatus.RECOVERY_STATUS_LITIGATION;
        case 5:
        case "RECOVERY_STATUS_CP_SAVE":
            return exports.RecoveryStatus.RECOVERY_STATUS_CP_SAVE;
        case 6:
        case "RECOVERY_STATUS_CP_RECOVERY":
            return exports.RecoveryStatus.RECOVERY_STATUS_CP_RECOVERY;
        case 7:
        case "RECOVERY_STATUS_CP_LIQUIDATION":
            return exports.RecoveryStatus.RECOVERY_STATUS_CP_LIQUIDATION;
        case -1:
        case "UNRECOGNIZED":
        default:
            return exports.RecoveryStatus.UNRECOGNIZED;
    }
}
exports.recoveryStatusFromJSON = recoveryStatusFromJSON;
function recoveryStatusToJSON(object) {
    switch (object) {
        case exports.RecoveryStatus.RECOVERY_STATUS_UNSPECIFIED:
            return "RECOVERY_STATUS_UNSPECIFIED";
        case exports.RecoveryStatus.RECOVERY_STATUS_ANALYSIS:
            return "RECOVERY_STATUS_ANALYSIS";
        case exports.RecoveryStatus.RECOVERY_STATUS_FOLLOW_UP:
            return "RECOVERY_STATUS_FOLLOW_UP";
        case exports.RecoveryStatus.RECOVERY_STATUS_AMICABLE:
            return "RECOVERY_STATUS_AMICABLE";
        case exports.RecoveryStatus.RECOVERY_STATUS_LITIGATION:
            return "RECOVERY_STATUS_LITIGATION";
        case exports.RecoveryStatus.RECOVERY_STATUS_CP_SAVE:
            return "RECOVERY_STATUS_CP_SAVE";
        case exports.RecoveryStatus.RECOVERY_STATUS_CP_RECOVERY:
            return "RECOVERY_STATUS_CP_RECOVERY";
        case exports.RecoveryStatus.RECOVERY_STATUS_CP_LIQUIDATION:
            return "RECOVERY_STATUS_CP_LIQUIDATION";
        case exports.RecoveryStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.recoveryStatusToJSON = recoveryStatusToJSON;
//# sourceMappingURL=recovery_status.js.map